import { c as _c } from "react/compiler-runtime";
import { useMemo, useState } from 'react';
import clsx from 'clsx';
import { CampaignSliderCardVariant, ModuleBackgroundColor } from '@/types/amplience';
import Slider from '@/components/Slider/Slider';
import { getModuleBackgroundStyles } from '@/utility/getModuleBackgroundStyles';
import CampaignCard, { CampaignCardProps } from '../CampaignCard/CampaignCard';
import ProgressBar from '../ProgressBar/ProgressBar';
type CampaignSliderContent = {
  items: CampaignCardProps[];
  backgroundColor?: ModuleBackgroundColor;
  cardVariant?: CampaignSliderCardVariant;
  isLazyLoadingOff?: boolean;
};
export const CampaignSliderContent = t0 => {
  const $ = _c(28);
  const {
    items,
    cardVariant,
    backgroundColor,
    isLazyLoadingOff
  } = t0;
  const [progress, setProgress] = useState(0);
  let t1;
  if ($[0] !== backgroundColor) {
    t1 = getModuleBackgroundStyles(backgroundColor);
    $[0] = backgroundColor;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    textColor,
    isBackgroundBlack
  } = t1;
  let t2;
  if ($[2] !== cardVariant || $[3] !== isLazyLoadingOff || $[4] !== items || $[5] !== textColor) {
    let t3;
    if ($[7] !== cardVariant || $[8] !== isLazyLoadingOff || $[9] !== textColor) {
      t3 = (item, index) => <CampaignCard key={index} image={item.image} linkUrl={item.linkUrl} title={item.title} subtitle={item.subtitle} textColor={textColor} cardVariant={cardVariant} isLazyLoadingOff={isLazyLoadingOff} />;
      $[7] = cardVariant;
      $[8] = isLazyLoadingOff;
      $[9] = textColor;
      $[10] = t3;
    } else {
      t3 = $[10];
    }
    t2 = items.map(t3);
    $[2] = cardVariant;
    $[3] = isLazyLoadingOff;
    $[4] = items;
    $[5] = textColor;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const memoizedSliderItems = t2;
  const t3 = isBackgroundBlack ? "bg-white text-black" : "bg-black text-white";
  let t4;
  if ($[11] !== t3) {
    t4 = clsx("hidden! md:flex! lg:size-16", t3);
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const t5 = isBackgroundBlack ? "bg-white text-black" : "bg-black text-white";
  let t6;
  if ($[13] !== t5) {
    t6 = clsx("hidden! md:flex! lg:size-16", t5);
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t4 || $[16] !== t6) {
    t7 = {
      root: "[--slides-to-show:2.15] sm:[--slides-to-show:3.15] md:[--slides-to-show:4.18] lg:[--slides-to-show:4.2] xl:[--slides-to-show:4.15]",
      navPrev: t4,
      navNext: t6
    };
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== memoizedSliderItems || $[19] !== t7) {
    t8 = <Slider className={t7} onProgressChange={setProgress} showNavigation={true}>{memoizedSliderItems}</Slider>;
    $[18] = memoizedSliderItems;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  const t9 = items.length > 4;
  let t10;
  if ($[21] !== backgroundColor || $[22] !== progress || $[23] !== t9) {
    t10 = <div className="px-6 md:px-8 lg:px-16 xl:px-22.5"><ProgressBar progress={progress} background={backgroundColor} className="invisible md:visible" isVisible={t9} /></div>;
    $[21] = backgroundColor;
    $[22] = progress;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t10 || $[26] !== t8) {
    t11 = <div className="relative">{t8}{t10}</div>;
    $[25] = t10;
    $[26] = t8;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  return t11;
};